import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { LicensesState } from './licenses-data.service';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([LicensesState])
  ]
})
export class LicensesServicesModule { }
